module.exports = __webpack_public_path__ + "static/img/simei2.12f689ee.png";